import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../types/types';
import { FORM_ASK_FOR_VALIDATE } from './form-askfor-types';
import { getParameters } from '../../../helpers/helpers';

import { askForValidationUpload } from './form-askfor-file-upload';

interface IAskForValidation {
  askForId: number,
  askForText: string,
  cardGroupName: string,
  cardGroupID: number,
  validate: number,
  sequence: number,
  customerId: number,
  customerName: string
}

/**
 * Function that handles the Ask For question validation
 */
export const askForValidation = () => {
  if ( !FORM_ASK_FOR_VALIDATE.validateForm ) return;

  let askfor = getParameters('askforid');
  let cardgroupid = getParameters('cardgroupID');
  let isvalidated = getParameters('isvalidated');

  let askForData = [
    { askForId : 1, askForText: 'Driver Number', cardGroupName: 'AAG Test Cards', cardGroupID: 2481, validate: 0, sequence: 1, customerId: 113388, customerName: 'Blossman Gas' },
    { askForId : 4, askForText: 'Odometer', cardGroupName: 'AAG Test Cards', cardGroupID: 2481, validate: 0, sequence: 2, customerId: 113388, customerName: 'Blossman Gas' },
    { askForId : 5, askForText: 'Vehicle Number', cardGroupName: 'AAG Test Cards', cardGroupID: 2481, validate: 1, sequence: 3, customerId: 113388, customerName: 'Blossman Gas' },
  ];

  let existingData = [
    { Pin: 99999, Description: 'James Kirk' }
  ]

  const data: IAskForValidation = askForData.find((item: any) => item.askForId === +askfor )!;

  const { askForText, cardGroupName } = data;

  FORM_ASK_FOR_VALIDATE.validationTitle.innerText = `${isvalidated === '1' ? 'Edit' : 'Add'} ${askForText} question validation`;

  if (isvalidated === '1') {
    FORM_ASK_FOR_VALIDATE.askForValidationValues.value = `${existingData[0].Pin}  ${existingData[0].Description}\n`;
  }

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');

  // TODO: get individual ask for question from AWS 

  askForValidationUpload(isvalidated, existingData);
}